import { ExtranetCustomerGroupScheduleSlotDto } from '@pharmac-extranet/extranet-api'
import {
  CheckIcon,
  ExtranetContainer,
  ExtranetExpandSelectChevron,
  ExtranetScheduleSlotPicker,
  ExtranetTableColumn,
  ExtranetTableGroupColumn,
  ExtranetTableRow,
  useBreakpoint,
} from '@pharmac-extranet/shared'
import { PharmacLabel, PharmacText } from '@pharmac/ui'
import { t } from 'i18next'
import { useTranslation } from 'react-i18next'
import { range } from '../../utils/array.utils'
import { isWeekdaySunday, weekdayShortTranslations } from './util/date-utils'

type ScheduleSlotInputProps = {
  selectedSlotId: number | undefined
  availableScheduleSlots: ExtranetCustomerGroupScheduleSlotDto[]
  onChange: (slotId: number | undefined) => void
  error?: boolean
  nextOrderTime?: string
}

type SelectedSlotStringProps = {
  selectedSlot?: ExtranetCustomerGroupScheduleSlotDto
}

const SelectedSlotString = ({ selectedSlot }: SelectedSlotStringProps) => {
  const { t } = useTranslation(['common'])
  if (!selectedSlot) return <>-</>

  const { deadlineTime, deadlineWeekday, cycleDateIndex, id } = selectedSlot

  const weekNumber = isWeekdaySunday(cycleDateIndex) || id < 40 ? 1 : 2
  const weekdayTranslated = t(weekdayShortTranslations(deadlineWeekday) as any)

  return (
    <>
      <span>
        {t('common:week')} {weekNumber},{' '}
      </span>
      <span>
        {weekdayTranslated} {deadlineTime}
      </span>
    </>
  )
}

export const ScheduleSlotSelector = ({
  selectedSlotId,
  onChange,
  availableScheduleSlots,
  error,
  nextOrderTime,
}: ScheduleSlotInputProps) => {
  const selectedSlot = availableScheduleSlots.find((a) => a.id === selectedSlotId)

  const handleOnSelect = (slot: ExtranetCustomerGroupScheduleSlotDto) => {
    if (selectedSlotId === slot.id) {
      onChange(undefined)
    } else {
      onChange(slot.id)
    }
  }

  const { minDesktop } = useBreakpoint()

  const route = {
    id: 1,
    name: 'Testi',
    schedules: [
      {
        deadlineTime: '08:00',
        moveToProductionTime: '08:00',
        moveToProductionDayOffset: 1,
        productionTime: '08:00',
        productionDayOffset: 1,
        imagingTime: '08:00',
        imagingDayOffset: 1,
        inspectionTime: '08:00',
        inspectionDayOffset: 1,
        sendingTime: '08:00',
        sendingDayOffset: 1,
        deliveredDayOffset: 1,
        isActive: true,
      },
      {
        deadlineTime: '09:00',
        moveToProductionTime: '09:00',
        moveToProductionDayOffset: 1,
        productionTime: '09:00',
        productionDayOffset: 1,
        imagingTime: '09:00',
        imagingDayOffset: 1,
        inspectionTime: '09:00',
        inspectionDayOffset: 1,
        sendingTime: '09:00',
        sendingDayOffset: 1,
        deliveredDayOffset: 1,
        isActive: true,
      },
      {
        deadlineTime: '10:00',
        moveToProductionTime: '10:00',
        moveToProductionDayOffset: 1,
        productionTime: '10:00',
        productionDayOffset: 1,
        imagingTime: '10:00',
        imagingDayOffset: 1,
        inspectionTime: '10:00',
        inspectionDayOffset: 1,
        sendingTime: '10:00',
        sendingDayOffset: 1,
        deliveredDayOffset: 1,
        isActive: true,
      },
      {
        deadlineTime: '11:00',
        moveToProductionTime: '11:00',
        moveToProductionDayOffset: 1,
        productionTime: '11:00',
        productionDayOffset: 1,
        imagingTime: '11:00',
        imagingDayOffset: 1,
        inspectionTime: '11:00',
        inspectionDayOffset: 1,
        sendingTime: '11:00',
        sendingDayOffset: 1,
        deliveredDayOffset: 1,
        isActive: true,
      },
      {
        deadlineTime: '12:00',
        moveToProductionTime: '12:00',
        moveToProductionDayOffset: 1,
        productionTime: '12:00',
        productionDayOffset: 1,
        imagingTime: '12:00',
        imagingDayOffset: 1,
        inspectionTime: '12:00',
        inspectionDayOffset: 1,
        sendingTime: '12:00',
        sendingDayOffset: 1,
        deliveredDayOffset: 1,
        isActive: true,
      },
      {
        deadlineTime: '13:00',
        moveToProductionTime: '13:00',
        moveToProductionDayOffset: 1,
        productionTime: '13:00',
        productionDayOffset: 1,
        imagingTime: '13:00',
        imagingDayOffset: 1,
        inspectionTime: '13:00',
        inspectionDayOffset: 1,
        sendingTime: '13:00',
        sendingDayOffset: 1,
        deliveredDayOffset: 1,
        isActive: true,
      },
      {
        deadlineTime: '14:00',
        moveToProductionTime: '14:00',
        moveToProductionDayOffset: 1,
        productionTime: '14:00',
        productionDayOffset: 1,
        imagingTime: '14:00',
        imagingDayOffset: 1,
        inspectionTime: '14:00',
        inspectionDayOffset: 1,
        sendingTime: '14:00',
        sendingDayOffset: 1,
        deliveredDayOffset: 1,
        isActive: true,
      },
      {
        deadlineTime: '15:00',
        moveToProductionTime: '15:00',
        moveToProductionDayOffset: 1,
        productionTime: '15:00',
        productionDayOffset: 1,
        imagingTime: '15:00',
        imagingDayOffset: 1,
        inspectionTime: '15:00',
        inspectionDayOffset: 1,
        sendingTime: '15:00',
        sendingDayOffset: 1,
        deliveredDayOffset: 1,
        isActive: true,
      },
      {
        deadlineTime: '16:00',
        moveToProductionTime: '16:00',
        moveToProductionDayOffset: 1,
        productionTime: '16:00',
        productionDayOffset: 1,
        imagingTime: '16:00',
        imagingDayOffset: 1,
        inspectionTime: '16:00',
        inspectionDayOffset: 1,
        sendingTime: '16:00',
        sendingDayOffset: 1,
        deliveredDayOffset: 1,
        isActive: true,
      },
    ],
    urgentSchedule: {
      deadlineTime: '08:00',
      moveToProductionTime: '08:00',
      moveToProductionDayOffset: 1,
      productionTime: '08:00',
      productionDayOffset: 1,
      imagingTime: '08:00',
      imagingDayOffset: 1,
      inspectionTime: '08:00',
      inspectionDayOffset: 1,
      sendingTime: '08:00',
      sendingDayOffset: 1,
      deliveredDayOffset: 1,
    },
  }

  return (
    <ExtranetTableRow
      style={{
        background: 'var(--color-accent-1)',
        border:
          '1px solid ' + (error ? 'var(--input-error-border-color)' : 'var(--input-border-color)'),
        borderRadius: 'var(--input-border-radius)',
      }}
      expand={
        <ExtranetContainer
          flexColumn
          full
          paddingMedium
          style={{
            backgroundColor: '#FBFBFD',
            borderTop: '1px solid var(--color-accent-4)',
          }}
        >
          <PharmacLabel marginSmallVertical>{t('common:alternateWeek')} 1:</PharmacLabel>
          <ExtranetContainer
            full
            flexColumn={!minDesktop}
          >
            {range(0, 4).map((i) => (
              <ExtranetScheduleSlotPicker
                deliveryRoute={route}
                onSelect={handleOnSelect}
                scheduleSlots={availableScheduleSlots}
                selectedSlotId={selectedSlotId}
                isCustomerSelectionMode
                key={i}
                index={i}
              />
            ))}
          </ExtranetContainer>
          <PharmacLabel marginSmallVertical>{t('common:alternateWeek')} 2:</PharmacLabel>
          <ExtranetContainer
            paddingMediumBottom
            full
            flexColumn={!minDesktop}
          >
            {range(7, 11).map((i) => (
              <ExtranetScheduleSlotPicker
                deliveryRoute={route}
                onSelect={handleOnSelect}
                scheduleSlots={availableScheduleSlots}
                selectedSlotId={selectedSlotId}
                isCustomerSelectionMode
                key={i}
                index={i}
              />
            ))}
          </ExtranetContainer>
          <ExtranetContainer
            flexColumn={!minDesktop}
            justifyStart={!minDesktop}
            alignCenter={minDesktop}
            paddingSmallVertical
            full
          >
            <ExtranetContainer
              alignCenter
              flexRow
              half={minDesktop}
            >
              <CheckIcon icon="checkCircle" />
              <PharmacText
                weight="bold"
                marginSmallRight
              >
                {t('extranet:customerGroupSettings.nextOrderDeadline')}:
              </PharmacText>
              <PharmacText>{nextOrderTime}</PharmacText>
            </ExtranetContainer>
            <ExtranetContainer
              flexRow
              alignCenter
              paddingSmallVertical={!minDesktop}
              paddingLargeRight={minDesktop}
            >
              <ExtranetContainer
                marginSmallRight
                style={{
                  backgroundColor: 'var(--color-success)',
                  height: '1.5rem',
                  width: '1.5rem',
                  borderRadius: 'var(--border-radius-tiniest)',
                }}
              />
              <PharmacText>{t('extranet:customerGroupSettings.selectedOrderDeadline')}</PharmacText>
            </ExtranetContainer>
            <ExtranetContainer
              flexRow
              alignCenter
            >
              <ExtranetContainer
                marginSmallRight
                style={{
                  backgroundColor: 'var(--color-yellow)',
                  height: '1.5rem',
                  width: '1.5rem',
                  borderRadius: 'var(--border-radius-tiniest)',
                }}
              />
              <PharmacText>
                {t('extranet:customerGroupSettings.selectableOrderDeadline')}
              </PharmacText>
            </ExtranetContainer>
          </ExtranetContainer>
        </ExtranetContainer>
      }
      toggleExpand={() => null}
      children={({ isExpanded }) => (
        <ExtranetTableGroupColumn style={{ minHeight: 'var(--input-medium-height)' }}>
          <ExtranetTableRow style={{ fontWeight: 'bold' }}>
            <ExtranetTableColumn
              style={{
                padding: '0 0 0 .8rem',
                margin: 0,
                minHeight: 'var(--input-medium-height)',
                fontFamily: 'var(--input-font-family',
                fontSize: 'var(--input-medium-font-size)',
                fontWeight: 'var(--input-medium-font-weight)',
              }}
            >
              <SelectedSlotString selectedSlot={selectedSlot} />
            </ExtranetTableColumn>
            <ExtranetContainer>
              <ExtranetExpandSelectChevron isExpanded={isExpanded} />
            </ExtranetContainer>
          </ExtranetTableRow>
        </ExtranetTableGroupColumn>
      )}
    />
  )
}
